export default function roundNumber(number, decimals = 0) {
  const tenValue = Math.pow(10, decimals);

  return (decimals) ? Math.round((number * tenValue)) / tenValue : Math.round(number);
}


// WEBPACK FOOTER //
// ./src/shared/functions/roundNumber.js